import API from './index';

const api = {
    // getReportDetail({ params }) {
    //     return API.authAPI({
    //         url: '/approval/get-report-detail',
    //         method: 'GET',
    //         params: { ...params },
    //     });
    // },
    saveLocalSAE(data) {
        return API.authAPI({
            url: '/approval/save-local-sae',
            method: 'POST',
            data,
        });
    },
    submitLocalSAE(data) {
        return API.authAPI({
            url: '/approval/submit-local-sae',
            method: 'POST',
            data,
        });
    },
    // downloadDocument(data) {
    //     return API.authAPI({
    //         url: `/approval/download-supplementary/${data.id}`,
    //         method: 'GET',
    //         responseType: 'blob',
    //         timeout: 1000 * 60 * 10,
    //     });
    // },
};

export default api;
